import { TextField } from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const VictimContainer = styled.div`
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
  border-radius: 0px 0px 4px 4px;
  margin: 16px;
`;

export const Header = styled.div`
  display: flex;
  padding: 14px 16px;
  background-color: ${COLORS.LIGHT_GREEN};
`;

export const Content = styled.div`
  padding: 16px;
  display: flex;
`;

export const VictimTitle = styled.h2`
  margin: 8px;
`;

export const InputField = styled(TextField)`
  margin: 8px 10px;
  width: 70%;
  .MuiInputLabel-formControl {
    color: gray;
  }

  .Mui-focused {
    color: gray;
  }

  .MuiInput-underline.Mui-focused:after {
    display: none;
  }

  .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  }
`;
